import Icon from 'components/icon'
import type { IAssetCellProps } from './types'
import Centered from 'components/centered'

const AssetCell = (props: IAssetCellProps) => {
  const { title, titleClass, subtitle, subTitleClass, img, icon } = props
  return (
    <div class="flex flex-row items-center gap-2 w-full">
      <div class="shrink-0">
        {img && <img src={img} alt="" class="w-10 h-10 object-cover" />}
        {icon && (
          <Centered>
            <Icon src={icon} class="w-10 h-10" />
          </Centered>
        )}
      </div>
      <div class="flex-1 min-w-0">
        {' '}
        {/* Ensures this div takes up remaining space and respects shrink */}
        <div class={titleClass ? titleClass : "text-gray-900 text-xs font-semibold truncate"}>{title}</div>{' '}
        {/* Apply truncate here if needed */}
        {subtitle && <div class={subTitleClass ? subTitleClass : "text-gray-500 text-xs truncate"}>{subtitle}</div>}
      </div>
    </div>
  )
}

export default AssetCell
